<template>
    <div>
        <div v-if="list && list.length > 0" class="w-full" ref="categoriesRef">
            <ul class="list-none flex flex-wrap items-center mt-1 gap-1">
                <li v-for="category in formattedStoreItemCategories" :key="category.id"
                    class="bg-light-4 whitespace-nowrap overflow-hidden text-ellipsis max-w-max w-full text-[0.75rem] md:text-[0.781rem] 3xl:text-[0.813rem] text-[#333333] rounded-[0.313rem] py-1 px-5">
                    {{ category[finalizedNameKey] }}
                </li>
                <!-- seeMore -->
                <li v-if="seeMore.isExist" @click="() => seeMore.isExpand = !seeMore.isExpand"
                    class="bg-[#54526700] duration-100 list-none text-[#656565] hover:text-[#1d1d1d] hover:brightness-110 transition-[filter] hover:cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis max-w-max w-full text-[12px] md:text-[13px] rounded-[5px] py-1 px-5">
                    {{
            seeMore.isExpand
                ? $t("general.see_less")
                : $t("general.see_more")
        }}
                </li>
            </ul>
        </div>
        <div v-else class="flex-1 w-full text-[#000]">
            <strong
                class="inline-block text-[12px] mt-1 bg-light-4 whitespace-nowrap overflow-hidden text-ellipsis max-w-max w-full md:text-[13px] text-[#333333] rounded-[5px] py-1 px-5">{{
                $t("user.mix_attributes")
                }}</strong>
        </div>
    </div>
</template>

<script>
import { TextSeeMore } from "@/components";

export default {
    data() {
        return {
            seeMore: {
                isExist: false,
                isExpand: false,
                minCategoriesHeight: 50, //100px
                minCategoriesArrLength:15//5 items
            },
        }
    },
    props: {
        list: {
            type: Array,
            required: true,
            default: () => ([])
        },
        finalizedNameKey: {
            type: String,
            required: true,
            default: "name_ar",
        },
    },
    computed: {
        formattedStoreItemCategories() {
            const editedStoreItemCategories =
                this.seeMore.isExist && !this.seeMore.isExpand
                    ? this.list.slice(
                        0,
                        this.seeMore.minCategoriesArrLength
                    )
                    : this.list;
            return editedStoreItemCategories;
        },
    },
    methods: {
        checkCategoriesHeightLimit() {
            const condition =
                this.list &&
                this.list.length > this.seeMore.minCategoriesArrLength;
            if (condition) {
                this.seeMore.isExist = true;
            }
        },
    },
    components: {
        TextSeeMore,
    },
    watch: {
        "list.length": {
            immediate: true,
            handler() {
                this.checkCategoriesHeightLimit();
            }
        }
    }
}
</script>

<style></style>